import { useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Listbox } from "@headlessui/react";

import IconArrow from "assets/svg/chevron_right_black.svg";

import Input from "components/common/input";

import styles from "./styles.module.css";

const Dropdown = ({
  options,
  selected,
  onChange,
  placeholder = "Select an option",
  listClass,
  inputValue,
  handleInputChange,
  onOpenChange,
}) => {
  const listClasses = classNames({
    [styles.list]: true,
    [listClass]: listClass,
  });

  const buttonContentClass = classNames({
    [styles.buttonContent]: true,
    [styles.placeholder]: !selected,
  });

  const handleKeyDown = (event) => {
    if (event?.key === " ") {
      event.stopPropagation();
    }
  };

  return (
    <Listbox value={selected} onChange={onChange}>
      {({ open }) => {
        useEffect(() => {
          onOpenChange(open);
        }, [open]);

        return (
          <>
            <Listbox.Button aria-expanded={open ? "true" : "false"} className={styles.dropdown}>
              <span className={buttonContentClass}>{selected ? selected.name : placeholder}</span>
              <span className={styles.icon}>{<IconArrow />}</span>
            </Listbox.Button>
            <Listbox.Options className={listClasses}>
              <div className={styles.filterInput}>
                <Input
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  placeholder={placeholder}
                />
              </div>
              {options?.map((option) => (
                <Listbox.Option
                  key={option.id}
                  className={({ active }) => `${styles.option} ${active && styles.wildsand}`}
                  value={option}
                >
                  <span>{option.name}</span>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </>
        );
      }}
    </Listbox>
  );
};

Dropdown.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  listClass: PropTypes.any,
  selected: PropTypes.object,
  inputValue: PropTypes.string,
  handleInputChange: PropTypes.func,
  onOpenChange: PropTypes.func,
};

export default Dropdown;
